// Cookie-consent state. Pure storage — no posthog import (posthog.ts reads
// this at init; the banner calls phSetConsent which owns the runtime switch).
// `null` = no choice yet → the banner shows. Any choice is permanent until the
// visitor changes it on /legal/privacy.

export type Consent = 'granted' | 'denied';

const KEY = 'cr_consent';

export function getConsent(): Consent | null {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'granted' || v === 'denied' ? v : null;
  } catch {
    // storage blocked → treat as "no choice"; the banner may re-show, cookies
    // wouldn't stick anyway
    return null;
  }
}

export function storeConsent(v: Consent) {
  try {
    localStorage.setItem(KEY, v);
  } catch {
    /* no storage — the choice just doesn't persist */
  }
  // Same-page listeners (the banner) hide when the choice is made elsewhere
  // (the /legal/privacy prefs control). Storage events only fire cross-tab.
  try {
    window.dispatchEvent(new CustomEvent('cr-consent-changed', { detail: v }));
  } catch { /* ancient browser — banner just stays until reload */ }
}
